import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import { utils } from '../../lib'

class FileInputButton extends React.Component {

  handleClick = e => {
    e.preventDefault()
    e.stopPropagation()
    const event = new MouseEvent('click', { view: window, bubbles: false, cancelable: true })
    this.input.dispatchEvent(event)
  }

  handleChange = e => {
    const files = e.target.files
    if (files.length > 0 && this.props.onChange) {
      this.props.onChange(files.item(0))
    }
  }

  render() {
    const { disabled, children, accept } = this.props
    const filtered = utils.filter(this.props, {accept: true, children: true, onChange: true })
    return (
      <Button {...filtered} onClick={this.handleClick} disabled={disabled}>
        {children}
        <input type='file' onChange={this.handleChange} accept={accept} style={{display: 'none'}} ref={ref => this.input = ref} />
      </Button>
    )
  }
}

FileInputButton.defaultProps = {
  onChange: () => {}
}
FileInputButton.propTypes = {
  accept: PropTypes.string,
  onChange: PropTypes.func
}
export default FileInputButton



// WEBPACK FOOTER //
// ./src/components/widgets/FileInputButton.js